import { JSON } from '../json';
export class MapConverter {
    constructor(valueType) {
        if (valueType)
            this.valueType = valueType;
    }
    serialize(property) {
        const out = {};
        for (const entry of property.entries()) {
            const key = entry[0];
            const value = entry[1];
            out[key] = this.valueType ? JSON.serialize(value) : value;
        }
        return out;
    }
    deserialize(value) {
        const out = new Map();
        for (const property in value) {
            const propertyValue = this.valueType ? JSON.deserialize(value[property], this.valueType) : value[property];
            out.set(property, propertyValue);
        }
        return out;
    }
}
/*  Similar to MapConverter, it can be used this way:
 *	@JsonConverter(new NestedMapConverter<ClassA>(ClassA))
 *  readonly item: Map<string, Map<string, ClassA>>;
 *
 *  or
 *
 *  @JsonConverter(new NestedMapConverter<number>())
 *  readonly item: Map<string, Map<string, number>>;
 */
export class NestedMapConverter {
    constructor(valueType) {
        this.mapConverter = new MapConverter(valueType);
    }
    serialize(property) {
        const out = {};
        for (const entry of property.entries()) {
            const key = entry[0];
            const value = entry[1];
            out[key] = this.mapConverter.serialize(value);
        }
        return out;
    }
    deserialize(value) {
        const out = new Map();
        for (const property in value) {
            const propertyValue = this.mapConverter.deserialize(value[property]);
            out.set(property, propertyValue);
        }
        return out;
    }
}
/*  Similar to MapConverter, it can be used this way:
 *	@JsonConverter(new MultiValueMapConverter<ToolVariable | any>([ToolVariable]))
 *	readonly parameterValues?: Map<string, ToolVariable | any>;
 *
 *  By default it will use the first valid function to serial/deserial, or if it's a simple type (str/bool/etc) it'll use that
 */
export class MultiValueMapConverter {
    constructor(valueTypes) {
        this.valueTypes = valueTypes;
    }
    // eslint-disable-next-line class-methods-use-this
    serialize(property) {
        const out = {};
        for (const entry of property.entries()) {
            const key = entry[0];
            const value = entry[1];
            out[key] = JSON.serialize(value);
        }
        return out;
    }
    deserialize(value) {
        const out = new Map();
        // eslint-disable-next-line guard-for-in
        for (const property in value) {
            let propertyValue = value[property];
            for (const valueType of this.valueTypes) {
                try {
                    propertyValue = JSON.deserialize(value[property], valueType);
                    break; // use first valuetype that works
                }
                catch (e) {
                    continue;
                }
            }
            out.set(property, propertyValue);
        }
        return out;
    }
}
//# sourceMappingURL=map-converter.js.map